
namespace SorAraBul.Definitions {
    export class QuartersColumns {
        static columnsKey = 'Definitions.Quarters';
    }
}